import React from "react";
import Navbar from "../Component/Navbar";
import AffiliateAds from "../Component/AffiliateAds";
import Footer from "../Component/Footer";
import TopAds from "../Component/TopAds";
import BottomAds from "../Component/BottomAds";

function AffiliateAdsPage() {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <TopAds />
      <AffiliateAds />
      <BottomAds />
      <Footer />
    </div>
  );
}

export default AffiliateAdsPage;
